import axios from "axios";
const BaseURL = process.env.REACT_APP_API_PATH;

export const getAdminById = async (id) => {
  try {
    const res = await axios.get(`${BaseURL}/ebench/admin/get_admin_by_admin_id?adminId=${id}`);
    return res?.data // Return only the data part of the response
  } catch (error) {
    // You might want to handle specific error cases here
    throw new Error(`Failed to fetch admin with ID ${id}`);
  }
};


